import {
  CallDocument,
  MessageDocument,
  TCFunnelStatusHistoryDocument,
  TCSearcherTimelineItemDocument as SearcherTimelineItemDocument,
} from 'src/api/generated';

/**
 * Narrow a timeline item to a CallDocument.
 */
export function isCallItem(
  item: SearcherTimelineItemDocument
): item is CallDocument {
  return (
    typeof (item as { modelType?: unknown }).modelType === 'string' &&
    (item as { modelType: string }).modelType === CallDocument.modelType.CALL
  );
}

/**
 * Narrow a timeline item to a MessageDocument.
 */
export function isMessageItem(
  item: SearcherTimelineItemDocument
): item is MessageDocument {
  return item.modelType === MessageDocument.modelType.MESSAGE;
}

/**
 * Narrow a timeline item to a TCFunnelStatusHistoryDocument.
 */
export function isStatusHistoryItem(
  item: SearcherTimelineItemDocument
): item is TCFunnelStatusHistoryDocument {
  return (
    item.modelType === TCFunnelStatusHistoryDocument.modelType.STATUS_HISTORY
  );
}
